(function(a) {
    a.fn.loadingdots = function(b) {
        var c = 0,
            d = a.extend({}, {
                duration: 250
            }, b),
            e = function() {
                var g = a(this),
                    f, h = c * d.duration,
                    i = true;
                c++;
                f = function() {
                    if (!i) {
                        h = 0;
                    } else {
                        i = false;
                    }
                    g.delay(h).fadeTo(1000, 0.4).fadeTo(1000, 0, f);
                };
                f(i);
            };
        return this.each(function() {
            a(this).html('<span class="dot"></span><span class="dot"></span><span class="dot"></span>').find(".dot").each(e);
        });
    };
})(jQuery);